module.exports = __webpack_public_path__ + "img/icon_wealth.3997be27.svg";